import React from 'react';
import {Link} from 'gatsby';

import ArticleCardStyle from './ArticleCardStyle';

const ArticleCard = (props) => {
  const { imageUrl, title, date, author, slug } = props;
  return (
    <ArticleCardStyle imageUrl={imageUrl}>
      <Link to={slug}>
        <div className="articleImageAndTitle">
          <div className="articleImageContainer">
          {/* <img src={imageUrl} alt="" /> */}
          </div>
          <div className="articleTitle">{title}</div>
        </div>
        <div className="articleDateAndAuthor">
          <span className="date">{date}</span>
          { author &&
            <>
              <span className="verticalLine">|</span>
              <span className="author">{author}</span>
            </>
          }
        </div>
      </Link>
    </ArticleCardStyle>
  );
};

export default ArticleCard;
